import { render, staticRenderFns } from "./co2Emitted.vue?vue&type=template&id=87e7fe28&"
import script from "./co2Emitted.vue.js?vue&type=script&lang=js&"
export * from "./co2Emitted.vue.js?vue&type=script&lang=js&"
import style0 from "./co2Emitted.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports